module.exports = __webpack_public_path__ + "static/img/sv-5.649c6b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gallery/sv-5.jpg
// module id = BEIC
// module chunks = 0